const JWT_COOKIE_NAME = "jwtToken";
export class CookiesStorage {
    constructor(tokenReader, cookieManager) {
        this.cookies = cookieManager;
        this.tokenReader = tokenReader;
    }
    setToken(token) {
        const expirationDate = this.tokenReader.getExpirationDate(token);
        this.cookies.set(JWT_COOKIE_NAME, token, { expires: expirationDate });
    }
    getToken() {
        return this.cookies.get(JWT_COOKIE_NAME);
    }
}
//# sourceMappingURL=CookiesStorage.js.map